module.exports = __webpack_public_path__ + "static/media/img-heritage-area2-shuseikan02.28b3f5d1.jpg";